import { render, staticRenderFns } from "./ScopeOverview.vue?vue&type=template&id=3a9e9136&"
import script from "./ScopeOverview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ScopeOverview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ScopeOverview.vue?vue&type=style&index=0&id=3a9e9136&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports